import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=35c4b3f8&scoped=true&"
import script from "./FilterCard.vue?vue&type=script&lang=js&"
export * from "./FilterCard.vue?vue&type=script&lang=js&"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=35c4b3f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4b3f8",
  null
  
)

export default component.exports